// Подключаемая вёрстка

export default ({ cls, mods } = {}) => [
  {block: 'slider-navigation', cls, mods, content: [
      {elem: 'button', cls: 'swiper-button-next', content: [
          {block: 'btn', cls: 'btn-secondary', tag: 'button', attrs: {type: 'button'}},
        ]},
      {elem: 'button', cls: 'swiper-button-prev', content: [
          {block: 'btn', cls: 'btn-secondary', tag: 'button', attrs: {type: 'button'}},
        ]},
    ]}
];
